module.exports = __webpack_public_path__ + "img/visual_theme.93b55d70.png";